var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[(_vm.getImage)?_c('div',{class:_vm.$style.overlay,style:({ backgroundImage: `url(${_vm.getImage})` })}):_c(_vm.getDefaultImage,{directives:[{name:"fill",rawName:"v-fill:black",arg:"black"},{name:"opacity",rawName:"v-opacity",value:(.2),expression:".2"}],tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }